import { BrowserRouter, Routes, Route} from 'react-router-dom'
import Home from './pages/home/Home'
import About from './pages/home/About'
import Contact from './pages/contact/Contact'
import Portfolio from './pages/portfolio/Portfolio'
import NotFound from './pages/notFound/NotFound'
import Navbar from './components/Navbar'
import SocialMedia from './components/SocialMedia'
import Footer from './components/Footer'
import { useState, useEffect, createContext } from 'react'
import ReactSwitch from 'react-switch'
import {FaMoon} from 'react-icons/fa'
import {BsFillSunFill} from 'react-icons/bs'
import { Helmet } from 'react-helmet'
import image from '../src/images/Logo_type_aliquam.png'

export const ThemeContext = createContext(null)

const App = () => {
  const [theme, setTheme] = useState('dark')

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark'
    setTheme(newTheme)
    localStorage.setItem('theme', newTheme)
  }

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme')
    if (savedTheme) {
      setTheme(savedTheme)
    }
  }, [])

	return (
		<div className='mainClass'  id={theme}> 
			<Helmet>
				<title>Aliquam Studios</title>
				<meta property="og:image" content={image} />
			</Helmet>
			<ThemeContext.Provider value={{theme, toggleTheme}}>
			<div id={theme}>
				<SocialMedia/>
				<BrowserRouter>
					<Navbar/>
					<Routes>
						<Route index element={<Home/>}/>
						<Route path='/about#about' element={<About/>}/>
						<Route path='/marketplace'/>
						<Route path='/portfolio' element={<Portfolio/>}/>
						<Route path='/contact' element={<Contact/>}/>
						<Route path='/aliquam_creative'/>
						<Route path='*' element={<NotFound/>}/>
					</Routes>
				</BrowserRouter>
				<div className="switch">
					<ReactSwitch onChange={toggleTheme}  onColor="#fff" offColor='#1e1e1e' onHandleColor="#383838" offHandleColor="#f7f4f1" handleDiameter={25} uncheckedIcon={<BsFillSunFill className='sun'/>} checkedIcon={<FaMoon className='moon'/>} activeBoxShadow='#fff' height={30} width={60} checked={theme === 'light'}/>
				</div>
				<Footer/>
			</div>
			</ThemeContext.Provider>
		</div>
	)
};

export default App;
